import { getListViewTypeForFolder } from 'owa-mail-list-store';
export default function getListViewTypeFromScope(scope) {
    switch (scope.kind) {
        case "PrimaryMailbox" /* PrimaryMailbox */:
            return getFolderSearchScopeListViewType(scope);
        case "Group" /* Group */:
            return getSingleGroupSearchScopeListViewType(scope);
        default:
            throw new Error('Unregistered search scope');
    }
}
function getFolderSearchScopeListViewType(folderSearchScope) {
    return getListViewTypeForFolder(folderSearchScope.folderId);
}
export function getSingleGroupSearchScopeListViewType(singleGroupSearchScope) {
    return 0 /* Conversation */;
}
//# sourceMappingURL=getSearchScopeListViewType.js.map